(() => {
  const CONFIG = {
    apiDomain: "https://shopifycheckout.softcottonpocket.com",
    appProxyPrefix: "/a/n",
    checkoutPath: "/a/n/checkout/",
    adTrackingKey: "adTracking",
    userIdKey: "checkout_user_id",
  };

  let checkoutInFlight = false;
  let pixelsLoaded = false;
  const pixelConfigs = { facebook: [], tiktok: [] };

  function parseAdParamsFromURL() {
    const params = new URLSearchParams(window.location.search);
    const keys = [
      "gclid",
      "gbraid",
      "wbraid",
      "dclid",
      "gad_source",
      "gad_campaignid",
      "fbclid",
      "fb_ad_id",
      "ttclid",
      "campaign_id",
      "adset_id",
      "ad_id",
      "msclkid",
      "utm_source",
      "utm_medium",
      "utm_campaign",
      "utm_content",
      "utm_term",
      "utm_id",
    ];
    const out = {};
    let found = false;
    for (const key of keys) {
      const value = params.get(key);
      if (value) {
        out[key] = value;
        found = true;
      }
    }
    return found ? out : null;
  }

  function detectAdPlatform(params) {
    if (params.gclid || params.gbraid || params.wbraid || params.gad_source) return "google";
    if (params.fbclid || params.fb_ad_id) return "facebook";
    if (params.ttclid) return "tiktok";
    if (params.msclkid) return "bing";
    if (params.utm_source) return String(params.utm_source).toLowerCase();
    return "unknown";
  }

  function mapAdParamsToUtm(params, platform) {
    const mapping = {};
    if (platform === "google") {
      mapping.utm_source = "google";
      mapping.utm_medium = "cpc";
      if (params.gad_campaignid) mapping.utm_campaign = params.gad_campaignid;
    } else if (platform === "facebook") {
      mapping.utm_source = "facebook";
      mapping.utm_medium = "paid_social";
      if (params.campaign_id) mapping.utm_campaign = params.campaign_id;
    } else if (platform === "tiktok") {
      mapping.utm_source = "tiktok";
      mapping.utm_medium = "paid_social";
      if (params.campaign_id) mapping.utm_campaign = params.campaign_id;
    }

    const keep = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "utm_id"];
    for (const key of keep) {
      if (params[key]) mapping[key] = params[key];
    }
    return mapping;
  }

  function saveAdParamsToStorage() {
    const adParams = parseAdParamsFromURL();
    if (!adParams) return;
    const platform = detectAdPlatform(adParams);
    const data = {
      _last_click_source: platform,
      _last_click_time: new Date().toISOString(),
      ...adParams,
      ...mapAdParamsToUtm(adParams, platform),
    };
    localStorage.setItem(CONFIG.adTrackingKey, JSON.stringify(data));
  }

  function getStoredAdsData() {
    try {
      return JSON.parse(localStorage.getItem(CONFIG.adTrackingKey)) || {};
    } catch (_err) {
      return {};
    }
  }

  function getCookie(name) {
    const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
    return match ? match[2] : "";
  }

  function getOrCreateUserId() {
    let userId = localStorage.getItem(CONFIG.userIdKey);
    if (userId) return userId;
    userId =
      typeof crypto.randomUUID === "function"
        ? crypto.randomUUID()
        : Date.now().toString(36) + Math.random().toString(36).slice(2);
    localStorage.setItem(CONFIG.userIdKey, userId);
    return userId;
  }

  function getShopDomain() {
    return (window.Shopify && window.Shopify.shop) || "";
  }

  async function setShopifyVariables() {
    if (!window.Shopify || !window.Shopify.shop) return;
    const vars = {
      shopId: window.Shopify.shop,
      clientId: getCookie("_shopify_y"),
      currency: window.Shopify.currency,
      country: window.Shopify.country,
    };
    localStorage.setItem("shopifyVariables", JSON.stringify(vars));
  }

  async function stringToInt(value, digits) {
    const data = new TextEncoder().encode(value);
    const hashBuffer = await crypto.subtle.digest("SHA-256", data);
    const hashHex = Array.from(new Uint8Array(hashBuffer))
      .map((b) => b.toString(16).padStart(2, "0"))
      .join("");
    return parseInt(hashHex.slice(0, digits), 16);
  }

  const Loading = (() => {
    let styleMounted = false;
    const styleId = "pt-checkout-loader-style";

    function mountStyle() {
      if (styleMounted || document.getElementById(styleId)) return;
      const style = document.createElement("style");
      style.id = styleId;
      style.textContent =
        ".pt-checkout-loader{position:fixed;inset:0;display:flex;align-items:center;justify-content:center;background:rgba(255,255,255,.92);z-index:2147483646;opacity:0;transition:opacity .2s ease}" +
        ".pt-checkout-loader.active{opacity:1}" +
        ".pt-checkout-loader__ring{position:relative;width:72px;height:72px}" +
        ".pt-checkout-loader__ring::before{content:'';position:absolute;inset:0;border-radius:50%;border:2.5px solid #e5e7eb}" +
        ".pt-checkout-loader__ring::after{content:'';position:absolute;inset:0;border-radius:50%;border:2.5px solid transparent;border-top-color:#3b82f6;border-right-color:#3b82f6;animation:pt-spin 1s ease-in-out infinite}" +
        ".pt-checkout-loader__lock{position:absolute;inset:0;display:flex;align-items:center;justify-content:center}" +
        ".pt-checkout-loader__lock svg{width:22px;height:22px;fill:#6b7280}" +
        "@keyframes pt-spin{to{transform:rotate(360deg)}}";
      document.head.appendChild(style);
      styleMounted = true;
    }

    const lockSvg = '<svg viewBox="0 0 24 24"><path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2z"/></svg>';

    return {
      show() {
        mountStyle();
        if (document.querySelector(".pt-checkout-loader")) return;
        const el = document.createElement("div");
        el.className = "pt-checkout-loader";
        el.innerHTML =
          '<div class="pt-checkout-loader__ring" aria-hidden="true">' +
          '<div class="pt-checkout-loader__lock">' + lockSvg + '</div>' +
          '</div>';
        document.body.appendChild(el);
        requestAnimationFrame(() => { el.classList.add("active"); });
      },
      hide() {
        const el = document.querySelector(".pt-checkout-loader");
        if (el) {
          el.classList.remove("active");
          el.addEventListener("transitionend", () => el.remove(), { once: true });
          setTimeout(() => el.remove(), 300);
        }
      },
    };
  })();

  async function fetchJSON(url, options) {
    const resp = await fetch(url, options);
    let data = {};
    try {
      data = await resp.json();
    } catch (_err) {
      data = {};
    }
    return { ok: resp.ok, status: resp.status, data };
  }

  async function saveCartToBackend(payload) {
    const localEndpoint = CONFIG.appProxyPrefix + "/api/cart";
    let result = await fetchJSON(localEndpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    if (!result.ok || !result.data || result.data.success !== true) {
      result = await fetchJSON(CONFIG.apiDomain + "/api/cart", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
    }

    if (!result.ok || !result.data || result.data.success !== true) {
      throw new Error((result.data && result.data.error) || "Failed to save cart snapshot.");
    }
  }

  async function fetchCart() {
    const resp = await fetch("/cart.json", {
      method: "GET",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
    });
    if (!resp.ok) throw new Error("Failed to load cart.");
    return resp.json();
  }

  async function addToCart(variantId, quantity) {
    const resp = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify({
        items: [{ id: variantId, quantity }],
      }),
      credentials: "same-origin",
    });
    if (!resp.ok) throw new Error("Failed to add item to cart.");
    return resp.json();
  }

  async function loadPixelConfigs() {
    if (pixelsLoaded) return;
    const shop = getShopDomain();
    if (!shop) return;

    const localUrl = CONFIG.appProxyPrefix + "/api/configs?shop=" + encodeURIComponent(shop) + "&configs=pixel";
    let result = await fetchJSON(localUrl, { method: "GET" });

    if (!result.ok) {
      const remoteUrl = CONFIG.apiDomain + "/api/configs?shop=" + encodeURIComponent(shop) + "&configs=pixel";
      result = await fetchJSON(remoteUrl, { method: "GET" });
    }

    if (!result.ok || !result.data || !Array.isArray(result.data.pixel_configs)) {
      pixelsLoaded = true;
      return;
    }

    for (const p of result.data.pixel_configs) {
      if (p.channel === "facebook" && p.pixel_id && !pixelConfigs.facebook.includes(p.pixel_id)) {
        pixelConfigs.facebook.push(p.pixel_id);
        if (typeof window.fbq !== "undefined") window.fbq("init", p.pixel_id);
      }
      if (p.channel === "tiktok" && p.pixel_id && !pixelConfigs.tiktok.includes(p.pixel_id)) {
        pixelConfigs.tiktok.push(p.pixel_id);
        if (typeof window.ttq !== "undefined") window.ttq.load(p.pixel_id);
      }
    }

    pixelsLoaded = true;
  }

  function firePixelEvent(eventName, eventData, eventId) {
    if (pixelConfigs.facebook.length > 0 && typeof window.fbq !== "undefined") {
      window.fbq("track", eventName, eventData, eventId ? { eventID: eventId } : undefined);
    }
    if (pixelConfigs.tiktok.length > 0 && typeof window.ttq !== "undefined") {
      window.ttq.track(eventName, eventData);
    }
  }

  function getQuantityFromForm(form) {
    if (!form) return 1;
    const q = form.querySelector('input[name="quantity"], quantity-selector-component input[name="quantity"]');
    const parsed = parseInt(q && q.value ? q.value : "1", 10);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : 1;
  }

  function getVariantIdFromForm(form) {
    if (!form) return "";
    const el = form.querySelector('input[name="id"]');
    return el && el.value ? el.value : "";
  }

  function getFormFromBuyNowEvent(event) {
    const source = event && event.target instanceof Element ? event.target : null;
    if (source) {
      const node = source.closest("[data-pt-buy-now]");
      if (node) {
        const form = node.closest('form[data-type="add-to-cart-form"]');
        if (form) return form;
      }
    }
    return document.querySelector('form[data-type="add-to-cart-form"]');
  }

  async function my_checkout(event) {
    if (event && typeof event.preventDefault === "function") event.preventDefault();
    if (checkoutInFlight) return false;

    checkoutInFlight = true;
    Loading.show();

    try {
      await setShopifyVariables();
      await loadPixelConfigs();

      const cart = await fetchCart();
      if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) {
        window.location.href = "/cart";
        return false;
      }

      const shopDomain = getShopDomain();
      if (!shopDomain) throw new Error("Missing shop domain.");

      const cartToken = String(cart.token || "").split("?")[0];
      if (!cartToken) throw new Error("Missing cart token.");

      const str1 = await stringToInt(shopDomain, 6);
      const str2 = await stringToInt(cartToken, 8);
      const str3 = Math.floor(Date.now() / 1000);
      const eventNumber = String(str1) + "_" + String(str2) + String(str3);

      const token = btoa(cartToken + "-" + eventNumber);
      const query = btoa(JSON.stringify({ is_insurance: 0 }));

      await saveCartToBackend({
        token,
        shop_domain: shopDomain,
        cart_token: cartToken,
        cart_data: cart,
        ad_tracking: getStoredAdsData(),
        user_id: getOrCreateUserId(),
      });

      const eventData = {
        content_ids: cart.items.map((item) => item.variant_id),
        contents: cart.items.map((item) => ({
          product_id: item.variant_id,
          title: item.title,
          quantity: item.quantity,
          item_price: item.price / 100,
        })),
        num_items: cart.item_count,
        value: cart.total_price / 100,
        currency:
          (window.Shopify &&
            window.Shopify.currency &&
            (window.Shopify.currency.active || window.Shopify.currency.current)) ||
          cart.currency ||
          "USD",
      };

      firePixelEvent("InitiateCheckout", eventData, "InitiateCheckout" + eventNumber);
      window.location.href = CONFIG.checkoutPath + encodeURIComponent(token) + "?r=" + encodeURIComponent(query);
      return false;
    } catch (err) {
      console.error("[pt-checkout-hook] checkout redirect failed:", err);
      checkoutInFlight = false;
      Loading.hide();
      window.location.href = "/cart";
      return false;
    }
  }

  async function my_product_checkout(event) {
    if (event && typeof event.preventDefault === "function") event.preventDefault();
    if (checkoutInFlight) return false;
    Loading.show();

    try {
      const form = getFormFromBuyNowEvent(event);
      const variantId = getVariantIdFromForm(form);
      const quantity = getQuantityFromForm(form);
      if (!variantId) throw new Error("Variant not found.");

      await addToCart(variantId, quantity);
      return my_checkout();
    } catch (err) {
      console.error("[pt-checkout-hook] buy-now redirect failed:", err);
      Loading.hide();
      window.location.href = "/cart";
      return false;
    }
  }

  function isCartCheckoutButton(button) {
    if (!(button instanceof HTMLElement)) return false;
    if (!button.matches('button[name="checkout"], button[data-pt-checkout], #checkout')) return false;
    // Resolve the cart form this button submits: explicit form="..." id, else nearest ancestor <form>.
    const formAttr = button.getAttribute("form");
    let form = formAttr ? document.getElementById(formAttr) : null;
    if (!form) form = button.closest("form");
    if (!form) return false;
    const id = form.id || "";
    // Known cart form ids: Horizon (cart-form), Dawn page cart (cart), Dawn cart drawer (CartDrawer-Form).
    if (id === "cart-form" || id === "cart" || id === "CartDrawer-Form") return true;
    // Fallback: any form posting to the cart route (theme-agnostic).
    const action = form.getAttribute("action") || "";
    return action.indexOf("/cart") !== -1;
  }

  function bindDelegatedEvents() {
    document.addEventListener(
      "click",
      (event) => {
        const target = event.target;
        if (!(target instanceof Element)) return;

        const buyNowButton = target.closest("[data-pt-buy-now]");
        if (buyNowButton) {
          my_product_checkout(event);
          return;
        }

        const shopifyPaymentButton = target.closest(".shopify-payment-button__button");
        if (shopifyPaymentButton && shopifyPaymentButton.closest('form[data-type="add-to-cart-form"]')) {
          event.stopPropagation();
          my_product_checkout(event);
          return;
        }

        const checkoutButton = target.closest('button[name="checkout"], button[data-pt-checkout], #checkout');
        if (checkoutButton && isCartCheckoutButton(checkoutButton)) {
          my_checkout(event);
        }
      },
      true
    );

    document.addEventListener(
      "submit",
      (event) => {
        const form = event.target;
        if (!(form instanceof HTMLFormElement)) return;
        if (form.id !== "cart-form") return;

        const submitter = event.submitter;
        if (submitter && submitter instanceof HTMLElement && isCartCheckoutButton(submitter)) {
          my_checkout(event);
        }
      },
      true
    );
  }

  saveAdParamsToStorage();
  window.my_checkout = my_checkout;
  window.my_product_checkout = my_product_checkout;

  window.addEventListener("pageshow", (e) => {
    if (e.persisted) {
      checkoutInFlight = false;
      Loading.hide();
    }
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      bindDelegatedEvents();
      loadPixelConfigs();
    });
  } else {
    bindDelegatedEvents();
    loadPixelConfigs();
  }
})();
